import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initial = { name: "", email: "", phone: "", subject: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(initial);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in name, email and message.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contacts`, {
        ...form,
        phone: form.phone || null,
        subject: form.subject || null,
      });
      toast.success("Message sent. Our team will reach out shortly.");
      setForm(initial);
    } catch (err) {
      const msg =
        err?.response?.data?.detail?.[0]?.msg ||
        err?.response?.data?.detail ||
        "Could not submit. Please try again.";
      toast.error(typeof msg === "string" ? msg : "Submission failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      data-testid="contact-form"
      className="grid grid-cols-1 md:grid-cols-2 gap-5"
    >
      <div className="space-y-2">
        <Label htmlFor="c-name" className="text-slate-900 font-semibold">
          Full Name *
        </Label>
        <Input
          id="c-name"
          data-testid="contact-input-name"
          value={form.name}
          onChange={handleChange("name")}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="c-email" className="text-slate-900 font-semibold">
          Email *
        </Label>
        <Input
          id="c-email"
          type="email"
          data-testid="contact-input-email"
          value={form.email}
          onChange={handleChange("email")}
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="c-phone" className="text-slate-900 font-semibold">
          Phone
        </Label>
        <Input
          id="c-phone"
          data-testid="contact-input-phone"
          value={form.phone}
          onChange={handleChange("phone")}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="c-subject" className="text-slate-900 font-semibold">
          Subject
        </Label>
        <Input
          id="c-subject"
          data-testid="contact-input-subject"
          value={form.subject}
          onChange={handleChange("subject")}
        />
      </div>
      <div className="space-y-2 md:col-span-2">
        <Label htmlFor="c-msg" className="text-slate-900 font-semibold">
          Message *
        </Label>
        <Textarea
          id="c-msg"
          data-testid="contact-input-message"
          value={form.message}
          onChange={handleChange("message")}
          rows={5}
          required
        />
      </div>
      <div className="md:col-span-2">
        <Button
          type="submit"
          data-testid="contact-submit-button"
          disabled={submitting}
          className="gradient-accent text-white font-semibold uppercase tracking-wider rounded-md hover:opacity-90 transition-opacity h-12 px-8"
        >
          {submitting ? "Sending..." : "Send Message"}
        </Button>
      </div>
    </form>
  );
};

export default ContactForm;
